import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { Menu, Phone, X, Zap } from "lucide-react";
import logo from "../assets/website-logo-2.png";

export const CONTACT_NUMBER = "+91 90809 73764";

const socialLinks = [
  { name: "LinkedIn", href: "https://www.linkedin.com/company/ev91/", icon: <FaLinkedinIn /> },
  { name: "Instagram", href: "https://www.instagram.com/ev91technologiespvtltd", icon: <FaInstagram /> },
  { name: "Twitter", href: "https://x.com/Voice12841491", icon: <FaTwitter /> },
  { name: "Facebook", href: "https://www.facebook.com/voice9380", icon: <FaFacebookF /> },
];

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about-us" },
  { name: "Services", path: "/services" },
  { name: "Life @ Voice", path: "/life-voice" },
  { name: "Blogs", path: "/blog" },
  { name: "Contact", path: "/contact-us" },
];

const Header = () => {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <header className="fixed left-0 top-0 z-50 w-full border-b border-emerald-100 bg-white text-slate-950 shadow-xl shadow-slate-900/8  backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-3 py-3.5 sm:px-4 lg:px-4">
        <Link to="/" className="-ml-3 flex items-center gap-3 sm:-ml-5 lg:-ml-10 xl:-ml-14" onClick={() => setIsMobileMenuOpen(false)}>
          <span className="relative grid place-items-center overflow-visible">
            <img
  src={logo}
  alt="EV91 Logo"
  className="h-10 w-auto rounded-md"
/>
          </span>
          {/* <span className="leading-tight">
            <span className="block text-xl font-black tracking-tight">EV91</span>
            <span className="block text-[11px] font-bold uppercase tracking-[0.24em] text-emerald-700">VOICE</span>
          </span> */}
        </Link>

        <nav className="hidden items-center rounded-full border border-emerald-100 bg-emerald-50/80 px-2 py-2 lg:flex">
          {navLinks.map(({ name, path }) => {
            const isActive = location.pathname === path;
            return (
              <Link
                key={path}
                to={path}
                className={`rounded-full px-4 py-2 text-sm font-bold transition ${
                  isActive ? "bg-slate-950 text-white" : "text-slate-700 hover:bg-white hover:text-emerald-800"
                }`}
              >
                {name}
              </Link>
            );
          })}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href={`tel:${CONTACT_NUMBER.replace(/\s+/g, "")}`}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-emerald-100 bg-emerald-50 text-emerald-800 transition hover:bg-emerald-100"
            aria-label="Call EV91"
          >
            <Phone className="h-4 w-4" />
          </a>
          <div className="flex items-center gap-1">
            {socialLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="grid h-10 w-10 place-items-center rounded-full text-slate-600 transition hover:bg-emerald-50 hover:text-emerald-800"
                aria-label={link.name}
              >
                {link.icon}
              </a>
            ))}
          </div>
          <button
            className="inline-flex items-center gap-2 rounded-full bg-slate-950 px-5 py-2.5 text-sm font-black text-white shadow-lg shadow-slate-900/15 transition hover:-translate-y-0.5 hover:bg-emerald-700"
            onClick={() => window.dispatchEvent(new CustomEvent("openJoinNowModal"))}
          >
            <Zap className="h-4 w-4" />
            Get EV
          </button>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen((open) => !open)}
          className="grid h-11 w-11 place-items-center rounded-full border border-emerald-100 bg-emerald-50 text-slate-950 lg:hidden"
          aria-label="Toggle navigation"
        >
          {isMobileMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      <div className={`lg:hidden ${isMobileMenuOpen ? "block" : "hidden"}`}>
        <div className="mx-4 mb-4 rounded-3xl border border-emerald-100 bg-white p-3 shadow-2xl">
          <nav className="grid gap-1">
            {navLinks.map(({ name, path }) => (
              <Link
                key={path}
                to={path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`rounded-2xl px-4 py-3 font-bold ${
                  location.pathname === path ? "bg-slate-950 text-white" : "text-slate-700 hover:bg-emerald-50"
                }`}
              >
                {name}
              </Link>
            ))}
          </nav>
          <button
            className="mt-3 inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 px-5 py-3 font-black text-white"
            onClick={() => {
              setIsMobileMenuOpen(false);
              window.dispatchEvent(new CustomEvent("openJoinNowModal"));
            }}
          >
            <Zap className="h-4 w-4" />
            Get EV
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
